import script from "./SkillSettingsInline.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillSettingsInline.vue?vue&type=script&setup=true&lang=js"

import "./SkillSettingsInline.vue?vue&type=style&index=0&id=6cc0e95c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cc0e95c"]])

export default __exports__